export const twoFactorAuthenticationMixin = {
  data() {
    return {
      opened2FArequired: false
    }
  },

  methods: {
    companie2FArequired(){
      this.opened2FArequired = !!localStorage.getItem("user_has_2fa") ?
        localStorage.getItem('2fa_required') === 'true' && localStorage.getItem("user_has_2fa") === "null" :
        localStorage.getItem('2fa_required') === 'true';
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/twoFactorAuthenticationMixin.js